export default "__VITE_ASSET__Crsp_Rxz__"